<template>
  <div class="transition">
    <BasicText size="h5">Souhaitez-vous accéder aux données de toute l’entreprise ou uniquement à celle d’un établissement en particulier ?</BasicText>
    <div class="transition-items flex-1">
        <BasicCheckbox
          label="Toute l’entreprise"
          @update:model-value="typeEntite = 'entreprise'"
          :model-value="typeEntite === 'entreprise'"
        />
        <BasicAlert
          alert-type="info"
          alert-label="Une entreprise est composée d’un ou plusieurs établissements, vous les verrez tous. C’est l’option à privilégier pour les petites et moyennes entreprises."
          class="flex-none"
        />
      </div>
    <div class="transition-items">
      <BasicCheckbox
        label="Seulement un établissement"
        @update:model-value="typeEntite = 'etablissement'"
        :model-value="typeEntite === 'etablissement'"
      />
      <BasicAlert
        alert-type="info"
        alert-label="Vous n’aurez accès qu’aux données de l’établissement sélectionné, ce choix n’est généralement pertinent que pour les grandes entreprises. Il sera nécessaire de faire une demande par établissement si vous devez en gérer plusieurs."
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { BasicAlert, BasicCheckbox, BasicText } from '@designSystem/components'
  import type { DemandeRattachementResult } from '../types'
  import { computed } from 'vue'

  type In = void
  type Out = Pick<DemandeRattachementResult, 'typeEntite'>
  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const typeEntite = computed({
    get: () => props.out?.typeEntite,
    set: (value) => emits('outChanged', true, { typeEntite: value! }),
  })
</script>

<style lang="less" scoped>
  @import './ChoixCarte.less';

  .transition {
    max-width: 800px;
  }

  .checkbox {
    margin-left: 11px;
  }

  .icon {
    transform: scale(2);
    margin: 24px;
  }
</style>
